/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInstrumentLinksByInstrumentToken} from '../api'

 export const useQueryGetInstrumentLinksByInstrumentToken = createReactQueryHook('getInstrumentLinksByInstrumentToken', getInstrumentLinksByInstrumentToken)
